import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  // Button,
  Grid,
  // SvgIcon,
  Typography,
} from '@material-ui/core';
// import {
//   PlusCircle as PlusCircleIcon,
// } from 'react-feather';
import useStyles from './styles';

function Header({ className, ...rest }) {
  const classes = useStyles();

  return (
    <Grid
      className={clsx(classes.emptyRoot, className)}
      container
      justifyContent="space-between"
      spacing={3}
      {...rest}
    >
      <Grid item>
        <Typography
          variant="h3"
          color="textPrimary"
        >
          Ciclos de performance - Instancias
        </Typography>
      </Grid>
      {/* <Grid item>
        <Button
          color="secondary"
          variant="contained"
          className={classes.action}
          href="/administracion/performance-cycle-instances/create"
        >
          <SvgIcon
            fontSize="small"
            className={classes.actionIcon}
          >
            <PlusCircleIcon />
          </SvgIcon>
          Agregar instancia
        </Button>
      </Grid> */}
    </Grid>
  );
}

Header.propTypes = {
  className: PropTypes.string,
};

export default Header;
